// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import { withRichTextEditorMetrics } from '../../../metrics/protected/wrappers';
import { PopOutComposeEditor } from './PopOutComposeEditor';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A FloatingComposeEditor that chooses between two implementations of the composer
 * depending on the status of a gate. Shows a pop-out capable variant to users who
 * are ungated, and the original component to everyone else.
 */
export const _FloatingComposeEditor = props => {
  return /*#__PURE__*/_jsx(PopOutComposeEditor, Object.assign({}, props));
};
_FloatingComposeEditor.displayName = 'FloatingComposeEditor';
export const FloatingComposeEditor = withRichTextEditorMetrics('floating-compose', provideThreadView(_FloatingComposeEditor));
FloatingComposeEditor._WrappedComponent = _FloatingComposeEditor;